const PLACEHOLDER_TEXT = "-";

function isEmptyDisplayValue(value) {
  return !value || value === "null" || value === PLACEHOLDER_TEXT;
}

function formatDisplayValue(value) {
  if (isEmptyDisplayValue(value)) {
    return PLACEHOLDER_TEXT;
  }
  return `${value}`;
}

export function isAnonymizationEnabled(accountInfo) {
  return accountInfo?.anonymization === true;
}

export function anonymizeName(value) {
  const displayValue = formatDisplayValue(value);
  if (displayValue === PLACEHOLDER_TEXT) {
    return displayValue;
  }

  const characters = Array.from(displayValue);
  if (characters.length >= 3) {
    return `${characters[0]}*${characters[characters.length - 1]}`;
  }
  if (characters.length === 2) {
    return `${characters[0]}*`;
  }
  return "*";
}

export function anonymizeMobile(value) {
  const displayValue = formatDisplayValue(value);
  if (displayValue === PLACEHOLDER_TEXT) {
    return displayValue;
  }

  if (/^\d{11}$/.test(displayValue)) {
    return `${displayValue.slice(0, 3)}****${displayValue.slice(7)}`;
  }
  return displayValue;
}

export function getDisplayName(value, accountInfo) {
  return isAnonymizationEnabled(accountInfo)
    ? anonymizeName(value)
    : formatDisplayValue(value);
}

export function getDisplayMobile(value, accountInfo) {
  return isAnonymizationEnabled(accountInfo)
    ? anonymizeMobile(value)
    : formatDisplayValue(value);
}
